/**
 * Кастомная иконка «Профиль» для нижнего меню
 *
 * fill="currentColor" для окрашивания через Tailwind
 * Совместима с IconComponent (принимает size, style, className)
 */

import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  size?: number | string;
  style?: CSSProperties;
}

export function ProfileIcon({ className, size, style }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0282 14.0011C8.13697 14.0011 4.84888 16.1672 4.84888 18.7311C4.84888 22.0465 10.2521 22.0465 12.0282 22.0465C15.111 22.0465 19.2096 21.7049 19.2096 18.7522C19.2096 16.1762 15.9205 14.0011 12.0282 14.0011Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0291 11.8199H12.0615C13.3337 11.8159 14.5283 11.3045 15.4243 10.3812C16.3212 9.45795 16.8124 8.23326 16.8075 6.93423C16.8075 4.2387 14.6649 2.04651 12.0291 2.04651C9.39432 2.04651 7.25171 4.2387 7.25171 6.93423C7.25171 9.62774 9.39432 11.8199 12.0291 11.8199Z"
        fill="currentColor"
      />
    </svg>
  );
}